import { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import Big from 'big.js'
import { ROUNDING_PRECISIONS } from 'utils/constants'
import TotalsRow from './TotalsRow'
import type { InvoicePaymentCreation } from 'components/containers/invoice-payments/types'
import { safeNumber } from 'components/containers/invoice-payments/utils/utils'

interface TotalsRowCreateBulkInvoiceProps {
  selectedInvoices: InvoicePaymentCreation[]
}

export const TotalsRowCreateBulkInvoice: React.FC<TotalsRowCreateBulkInvoiceProps> = ({ selectedInvoices }) => {
  const { getValues, control } = useFormContext()

  const invoicesFormData = useWatch({
    control,
    name: 'invoices',
    defaultValue: {},
  })

  const totals = useMemo(() => {
    return selectedInvoices.reduce(
      (acc, invoice) => {
        const invoiceFormData = invoicesFormData?.[invoice.id] || {}
        const amountDue = Big(safeNumber(invoice.amountDue))
        const amountPaid = Big(safeNumber(invoiceFormData.amountPaid))
        const adjustment = Big(safeNumber(invoiceFormData.adjustment))
        const remainder = amountDue.sub(amountPaid).sub(adjustment).round(ROUNDING_PRECISIONS.COST)

        acc.amountDue = Big(acc.amountDue).plus(amountDue).toNumber()
        acc.amountPaid = Big(acc.amountPaid).plus(amountPaid).toNumber()
        acc.adjustment = Big(acc.adjustment).plus(adjustment).toNumber()
        acc.remainder = Big(acc.remainder).plus(remainder).toNumber()

        return acc
      },
      { amountDue: 0, amountPaid: 0, adjustment: 0, remainder: 0 },
    )
  }, [selectedInvoices, invoicesFormData])

  const paymentAmount = Number(getValues('paymentAmount'))

  return <TotalsRow totals={totals} paymentAmount={paymentAmount} />
}

export default TotalsRowCreateBulkInvoice
